<template>
  <div :id="iconName">
      <h6>{{ iconName }}</h6>
      <p><a class="text-muted" :href="require(`@/assets/gel/images/icons/${iconName}.svg`)" download><i data-toggle="tooltip" data-placement="top" title="Click to download SVG" :class="`gel-icon-2x gel-icon-${iconName}`"></i></a></p>
      <small><code>.gel-icon-{{ iconName }}</code></small>
  </div>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    iconName: String
  },
}
</script>